import { createAsyncAction } from "typesafe-actions";
import { Address } from "../../lib/model/Address";

export const fetchAddressesAsync = createAsyncAction(
  "addresses/FETCH_ADDRESSES_REQUEST",
  "addresses/FETCH_ADDRESSES_SUCCESS",
  "addresses/FETCH_ADDRESSES_FAILURE"
)<void, Address[], Error>();
